import Viewer from "./Viewer"
import Editor from "./Editor"

export default {
    name: "document",
    title: "Document",
    icon: require("./content-icon.svg"),
    category: "document",
    Viewer,
    Editor,
    Preview: Viewer
}